import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

//components
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'

//api
import { PromptService } from '../../../../service/prompt-service'

const PromptList = ({ reloadList }) => {
  const navigate = useNavigate()
  const [prompts, setPrompts] = useState([])

  useEffect(() => {
    const fetchPrompts = () => {
      PromptService.getAllPrompts(
        (data) => {
          if (data && Array.isArray(data.results)) {
            setPrompts(data.results)
          } else {
            const errorMessage =
              'La risposta non contiene un array valido di prompt.'
            console.error(errorMessage)
          }
        },
        (error) => {
          console.error('Errore durante il recupero dei prompt: ', error)
        }
      )
    }
    fetchPrompts()
  }, [reloadList])

  return (
    <div className="prompt__ComponentWrapper">
      <h3>Lista dei Prompt</h3>
      <div className="card ">
        <div>
          <DataTable
            value={prompts}
            tableStyle={{ minWidth: '50rem' }}
            style={{ marginRight: '2rem' }}
          >
            <Column field="name" header="Nome Prompt"></Column>
            <Column field="content" header="Anteprima Prompt" className='prompt__PromptContent'></Column>
            <Column
              field="is_default"
              header="Default"
              body={(rowData) => (
                <>
                  <i
                    className={
                      rowData.is_default
                        ? 'pi pi-check icon-green'
                        : 'pi pi-times icon-red'
                    }
                  ></i>
                </>
              )}
            ></Column>
            <Column
              field="is_system"
              header="Sistema"
              body={(rowData) => (
                <>
                  <i
                    className={
                      rowData.is_system
                        ? 'pi pi-check icon-green'
                        : 'pi pi-times icon-red'
                    }
                  ></i>
                </>
              )}
            ></Column>
            <Column
              header=""
              body={(rowData) => (
                <Button
                  label="Gestisci"
                  className="p-button-sm"
                  onClick={() => {
                    const promptId = rowData.id
                    navigate(`/dashboard/prompt/${promptId}`)
                  }}
                />
              )}
            ></Column>
          </DataTable>
        </div>
      </div>
    </div>
  )
}

export default PromptList
